const TRANSLATION_KEY_PATTERN = "^[A-Za-z0-9_-]{1,128}$";
const TRANSLATION_KEY_REGEX = new RegExp(TRANSLATION_KEY_PATTERN);

const isValidTranslationKey = (key) =>
  TRANSLATION_KEY_REGEX.test(key || "");

const getTranslationKeyError = (key) => {
  if (!key) return "Clé requise";
  return isValidTranslationKey(key)
    ? ""
    : "A–Z, a–z, 0–9, _ ou - (max 128)";
};

module.exports = {
  TRANSLATION_KEY_PATTERN,
  TRANSLATION_KEY_REGEX,
  isValidTranslationKey,
  getTranslationKeyError,
};
